<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form
          :inline="true"
          :model="form"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item label="标题">
            <el-input v-model="form.title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="宽">
            <el-input v-model="form.width" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="高">
            <el-input v-model="form.height" size="mini"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getTable(currentPage, pageSize)"
              >查询</el-button
            >
            <el-button type="danger" @click="clear">清空</el-button>
            <el-button type="danger" @click="random">随机</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2"></el-col>
    </el-row>
    <!-- <el-table
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :data="tableData"
      style="width: 100%"
      border
      :header-cell-style="{ background: '#E5E7EE', color: '#000000' }"
      size="mini"
    >
      <el-table-column prop="id" label="编号" align="center" width="55">
      </el-table-column>
      <el-table-column prop="newName" label="图片名称" align="center">
      </el-table-column>
      <el-table-column prop="title" label="图标标题" align="center">
      </el-table-column>
      <el-table-column prop="size" label="大小" align="center">
      </el-table-column>
      <el-table-column prop="path" label="图片" align="center">
        <template slot-scope="scope">
          <img
            :src="settings.apiBaseImg + scope.row.path"
            alt="logo"
            width="100px"
            height="80px"
          />
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="更多操作">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="getPic(scope.$index, scope.row)"
            type="text"
            size="small"
          >
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <ul class="pics">
      <li v-for="(item, index) in tableData" :key="item.id">
        <div class="mypics">
          <img :src="settings.apiBaseImg + item.path" alt="" />
        </div>
        <div class="texts">
          <h4>{{ item.title }}</h4>
          <p>宽：{{ item.width }} 高：{{ item.height }}</p>
          <button class="buttons" @click="getPic(index, item)">选择</button>
        </div>
      </li>
    </ul>
    <el-pagination
      v-if="show === true"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[8, 16, 32, 64]"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: true,
      dialogVisible: false,
      tableData: [],
      currentPage: 1,
      pageSize: 8,
      total: 0,
      loading: false,
      form: {
        title: '',
        width: '',
        height: ''
      }
    }
  },
  created () {
    this.getTable(this.currentPage, this.pageSize)
  },
  methods: {
    // 获取随机的素材
    async random () {
      const { data: res } = await this.$http({
        method: 'get',
        url: '/api/v1/picmate/random',
        params: {
          title: this.form.title,
          width: this.form.width,
          height: this.form.height
        }
      })
      console.log(res)
      this.show = false
      if (res.status === 200) {
        this.tableData = res.data
      }
    },
    // 获取素材库数据
    getTable (currentPage, pageSize) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/picmate/page',
        params: {
          title: this.form.title,
          width: this.form.width,
          height: this.form.height,
          pageSize: pageSize,
          pageNum: currentPage
        }
      }).then((res) => {
        if (res.status == 200) {
          this.show = true
          this.loading = false
          this.tableData = res.data.data.data
          this.total = res.data.data.total
        } else {
          obj.$message.error(res.message)
        }
      })
    },
    clear () {
      this.show = true
      this.form.title = ''
      this.form.width = ''
      this.form.height = ''
      this.getTable(this.currentPage, this.pageSize)
    },
    // 分页事件
    handleSizeChange (val) {
      this.pageSize = val // 将每页显示的条数 = 改变的值
      this.getTable(this.currentPage, this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTable(this.currentPage, this.pageSize)
    },
    getPic (index, row) {
      this.$emit('selectPic', index, row)
    }
  }
}
</script>

<style scoped>
.pics {
  padding: 0 30px;
  overflow: hidden;
  margin: 0 auto;
}
.pics li {
  width: 23.5%;
  height: 230px;
  border: 1px solid #ccc;
  float: left;
  margin-right: 2%;
  list-style: none;
  margin-top: 20px;
}
.pics li:nth-child(4n) {
  margin-right: 0px;
}
.mypics {
  width: 100%;
  height: 120px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e1e1e1;
}
.pics li img {
  width: 100%;
  margin: 0 auto;
}
.texts {
  padding: 10px 20px;
  text-align: center;
}
.texts > h4 {
  color: #333;
  font-size: 16px;
}
.texts > p {
  color: #666;
  font-size: 12px;
  margin-top: 6px;
}
.buttons {
  width: 80px;
  background: crimson;
  color: #fff;
  height: 26px;
  border: 0 none;
  border-radius: 13px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/picFile.vue